import { httpClient } from "@/app/client/httpClient";
import {
  BalanceHistory,
  BalanceHistoryTransactionType
} from "@/types/balance/BalanceHistory";
import { PageableRequest } from "@/types/PageableRequest";

class SalaryService {
  fetchBalance() {
    return httpClient.balances.$get();
  }

  requestWithdraw(
    withdrawal: number,
    rewardTransactionHistoryIds: number[],
    balanceUpdatedAt: string
  ) {
    return httpClient.balances.request_withdraw.$post({
      body: {
        withdrawal,
        rewardTransactionHistoryIds,
        balanceUpdatedAt
      }
    });
  }

  fetchBalanceHistories(
    query?: PageableRequest<{
      created_at__gte: string;
      created_at__lte: string;
      transaction_type: BalanceHistoryTransactionType;
      transfer_request_id: number;
      transfer_request_related_with_reward_id: number;
      ordering: string;
    }>
  ) {
    return httpClient.balances.history.$get({
      query
    });
  }

  fetchWithdrawableRewardHistories(
    query?: PageableRequest<{
      ordering: string;
    }>
  ) {
    return httpClient.balances.withdrawable_reward_histories.$get({
      query
    });
  }

  fetchBankAccount() {
    return httpClient.accounts.me.bank_account.$get();
  }

  async fetchHasBankAccount() {
    try {
      await this.fetchBankAccount();
      // 銀行口座アカウントが見つかったらtrue
      return true;
    } catch {
      // 見つからなかったらfalse
      return false;
    }
  }

  createBankAccount(body: {
    bankCode: string;
    branchCode: string;
    branchName: string;
    accountNumber: string;
  }) {
    return httpClient.accounts.me.bank_account.$post({
      body
    });
  }

  updateBankAccount(body: {
    bankCode?: string;
    branchCode?: string;
    branchName?: string;
    accountNumber?: string;
  }) {
    return httpClient.accounts.me.bank_account.$patch({
      body
    });
  }

  getReward(history: BalanceHistory) {
    return history.amountExcludeOption + history.withholdingTax;
  }

  getTotalIncome(history: BalanceHistory) {
    return history.amountExcludeOption + history.optionValue;
  }
}

export const salaryService = new SalaryService();
